import React, { useEffect, useState, useRef } from 'react';
import { SearchIcon, UserIcon, BellIcon, MenuIcon, XIcon, ChevronDownIcon } from 'lucide-react';
export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false); // For demo purposes
  const [activeMenu, setActiveMenu] = useState(null);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // For demo purposes only - toggle login state
  const toggleLogin = () => {
    setIsLoggedIn(!isLoggedIn);
  };
  const toggleMenu = menu => {
    setActiveMenu(activeMenu === menu ? null : menu);
  };
  return <header className="fixed top-0 left-0 right-0 bg-white z-50 shadow-sm" data-id="element-2617">
      <div className="container mx-auto px-4 md:px-6" data-id="element-2618">
        <div className="flex items-center justify-between h-20" data-id="element-2619">
          <div className="flex items-center" data-id="element-2620">
            <a href="/" className="text-2xl font-bold text-charcoal" data-id="element-2621">
              Kivarro
            </a>
            <nav className="hidden md:flex ml-10 space-x-8" data-id="element-2622">
              <a href="/" className="text-charcoal/70 hover:text-teal" data-id="element-2623">
                Home
              </a>
              <a href="/courses" className="text-charcoal/70 hover:text-teal" data-id="element-2624">
                Courses
              </a>
              <a href="/minimal-home" className="text-charcoal/70 hover:text-teal" data-id="element-2625">
                Ireland Home
              </a>
              <a href="/about" className="text-charcoal/70 hover:text-teal" data-id="element-2626">
                About
              </a>
              <a href="/contact" className="text-charcoal/70 hover:text-teal" data-id="element-2627">
                Contact
              </a>
            </nav>
          </div>
          <div className="flex items-center" data-id="element-2628">
            <a href="/login" className="px-4 py-2 text-charcoal/70 hover:text-teal mr-4" data-id="element-2629">
              Log in
            </a>
            <a href="/signup" className="px-5 py-2.5 bg-teal text-white rounded-lg hover:bg-teal/90 transition-all duration-300 shadow-sm" data-id="element-2630">
              Sign up
            </a>
          </div>
        </div>
      </div>
    </header>;
};